import { channelTypes } from "@/mocks/homeData";

const stabilityStyle: Record<string, string> = {
  "稳定性 高": "bg-secondary-100 text-secondary-900",
  "稳定性 中": "bg-accent-100 text-accent-900",
  "稳定性 低": "bg-primary-100 text-primary-800",
};

export default function Channels() {
  return (
    <section id="channels" className="w-full scroll-mt-20 bg-background-100 py-16 md:py-24">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <div className="max-w-2xl">
          <span className="text-xs font-semibold tracking-[0.2em] text-accent-700">CHANNELS / 渠道类型</span>
          <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            观看渠道类型总览
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
            不同类型的渠道，在稳定性、清晰度与使用门槛上各有取舍。先弄清楚它们在做什么，再决定从哪一类入手，
            会比漫无目的地搜索高效得多。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {channelTypes.map((channel) => (
            <article
              key={channel.id}
              className="flex flex-col overflow-hidden rounded-xl border border-background-200 bg-background-50 transition-transform duration-300 hover:-translate-y-1"
            >
              <div className="h-40 w-full overflow-hidden">
                <img src={channel.image} alt={channel.imageAlt} className="h-full w-full object-top" />
              </div>

              <div className="flex flex-1 flex-col p-5">
                <div className="flex items-start justify-between gap-3">
                  <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-500 text-background-50">
                    <i className={`${channel.icon} text-lg`}></i>
                  </span>
                  <span
                    className={`rounded-full px-3 py-1 text-[11px] font-medium ${stabilityStyle[channel.stability]}`}
                  >
                    {channel.stability}
                  </span>
                </div>

                <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">{channel.name}</h3>
                <p className="mt-1 text-xs text-foreground-500">{channel.tagline}</p>

                <ul className="mt-4 space-y-2">
                  {channel.points.map((point) => (
                    <li key={point} className="flex gap-2 text-sm leading-relaxed text-foreground-700">
                      <i className="ri-check-line mt-0.5 text-accent-600"></i>
                      <span>{point}</span>
                    </li>
                  ))}
                </ul>

                <div className="mt-auto space-y-2 pt-5 text-xs">
                  <p className="flex gap-2 text-secondary-800">
                    <i className="ri-add-circle-line mt-0.5"></i>
                    <span>{channel.pros}</span>
                  </p>
                  <p className="flex gap-2 text-primary-700">
                    <i className="ri-error-warning-line mt-0.5"></i>
                    <span>{channel.cons}</span>
                  </p>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}